import React, { useEffect, useRef, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import WifiRoundedIcon from '@mui/icons-material/WifiRounded';

/**
 * Brief celebration when connectivity returns after an offline stretch.
 */
export default function BackOnlineToast() {
  const [open, setOpen] = useState(false);
  const wasOfflineRef = useRef(
    typeof navigator !== 'undefined' ? navigator.onLine === false : false
  );

  useEffect(() => {
    const onOffline = () => {
      wasOfflineRef.current = true;
    };
    const onOnline = () => {
      if (wasOfflineRef.current) {
        setOpen(true);
      }
      wasOfflineRef.current = false;
    };
    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={3200}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 1 }}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity="success"
        variant="filled"
        icon={<WifiRoundedIcon fontSize="inherit" />}
        sx={{
          alignItems: 'center',
          borderRadius: 3,
          fontWeight: 600,
          boxShadow: '0 14px 30px rgba(16, 185, 129, 0.25)',
        }}
      >
        Связь восстановлена
      </Alert>
    </Snackbar>
  );
}
